export const serverUrl={
    aws:'https://pyd0xvkp5g.execute-api.ap-south-1.amazonaws.com/default',
}